import { render, staticRenderFns } from "./IncidentComparison.vue?vue&type=template&id=1e8914f0&scoped=true&"
import script from "./IncidentComparison.vue?vue&type=script&lang=js&"
export * from "./IncidentComparison.vue?vue&type=script&lang=js&"
import style0 from "./IncidentComparison.vue?vue&type=style&index=0&id=1e8914f0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e8914f0",
  null
  
)

export default component.exports